'use client'
import NavigateRightIcon from '@/app/icons/navigate-right'
import { AdDecision } from '@/app/util/ads-endpoint'
import Attribution from '@/components/attribution-v2'
import UAParserContext from '@/context/ua-parser'
import { getGifHeight, getGifWidth } from '@giphy/js-util'
import { Gif, GifOverlayProps } from '@giphy/react-components'
import { useContext } from 'react'
import ScrollCarousel from '../scroll-carousel'
import { spotlightWidth } from './spotlight-util'

const GridOverlay = ({ gif, carouselData }: GifOverlayProps & { carouselData: AdDecision }) => {
    return (
        <div className="absolute inset-0">
            <Attribution user={gif.user} className="absolute bottom-2 left-2" />
            {carouselData?.cta_url && (
                <div
                    className="text-giphyWhite bg-giphyBlack/50 absolute bottom-2 right-2 flex h-[50px] items-center justify-center gap-2 rounded-md px-5 font-bold hover:bg-giphyBlack/80"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        window.open(carouselData.cta_url, '_blank')
                    }}
                >
                    {carouselData.cta_text} <NavigateRightIcon className="fill-giphyWhite size-3" />
                </div>
            )}
        </div>
    )
}
const MainGif = ({ data, width }: { data: AdDecision; width: number; height?: number }) => {
    const { gif } = data
    const aspectRatio = gif.images.original.width / gif.images.original.height
    return (
        <Gif
            gif={gif}
            width={width}
            percentWidth="100%"
            overlay={(props) => <GridOverlay {...props} carouselData={data} />}
            style={{ aspectRatio }}
            lazyLoad={false}
            // eslint-disable-next-line better-tailwindcss/no-unregistered-classes
            className="giphy-spotlight-grid"
        />
    )
}

const CarouselGif = ({ data, height }: { data: AdDecision; height: number }) => {
    const { gif, impression_url, click_url } = data
    return (
        <Gif
            gif={gif}
            key={gif.id}
            height={height}
            width={getGifWidth(gif, height)}
            className="shrink-0"
            hideAttribution
            onGifClick={() => {
                window.open(click_url, '_blank')
            }}
            onGifSeen={() => {
                try {
                    if (impression_url) fetch(impression_url)
                } catch (_e) {}
            }}
        />
    )
}

const carouselHeight = 124
const carouselId = 'giphy-xl-banner-carousel'

const SpotlightGrid = ({ data }: { data: AdDecision }) => {
    const { deviceType } = useContext(UAParserContext)
    return (
        <>
            <MainGif data={data} width={spotlightWidth} height={getGifHeight(data.gif, spotlightWidth)} />
            <ScrollCarousel
                height={carouselHeight}
                width={spotlightWidth}
                elementId={carouselId}
                deviceType={deviceType}
            >
                {data.subdecisions?.map((decision) => (
                    <CarouselGif key={decision.gif.id} data={decision} height={carouselHeight} />
                ))}
            </ScrollCarousel>
        </>
    )
}

export default SpotlightGrid
